import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FullWidthBannerConfig } from '../../../../core/models/interface/full-width-banner-config';

@Component({
  selector: 'app-full-width-banner',
  templateUrl: './full-width-banner.component.html',
  styleUrls: ['./full-width-banner.component.scss'],
})
export class FullWidthBannerComponent implements OnInit, OnDestroy {
  /**
   * optional properties may be omitted
   */
  @Input() config: FullWidthBannerConfig;

  constructor(private sanitization: DomSanitizer) {}

  ngOnInit() {}

  ngOnDestroy(): void {}

  getImageUrl() {
    return this.sanitization.bypassSecurityTrustStyle(
      `url(${this.config.image})`,
    );
  }
}
